import React from 'react';
import { SelectField, TFormField } from '@monorepo/forms';
import { enumToSelectOptions } from '@monorepo/helpers';
import { prepareOptions } from '@monorepo/ui-kit';
import { useI18n } from '@monorepo/i18n';
import { FAST_DEAL_DELIVERY_CONDITION } from '@monorepo/dictionary';

// Deprecated delivery conditions that should be disabled for new entries
const DEPRECATED_CONDITIONS = ['9', '10', '11', '13', '14'];

const DeliveryConditionSelect = <
  TFormValues extends Record<string, any> = Record<string, any>
>(
  props: TFormField<TFormValues>
) => {
  const { t } = useI18n();

  const options = prepareOptions(
    enumToSelectOptions(FAST_DEAL_DELIVERY_CONDITION),
    t,
    'deliverycondition.'
  )
    .map((option) => ({
      ...option,
      disabled: DEPRECATED_CONDITIONS.includes(option.value.toString())
    }))
    .sort((a, b) => {
      // Незаблокированные опции сверху, заблокированные внизу
      if (a.disabled === b.disabled) return 0;
      return a.disabled ? 1 : -1;
    });

  return (
    <SelectField<TFormValues>
      options={options}
      {...props}
    />
  );
};

export default DeliveryConditionSelect;
